/**
 * Cookie Consent Types
 *
 * GDPR-compliant cookie consent management
 */

export type CookieCategory = 'essential' | 'analytics' | 'marketing' | 'preferences';

export interface CookiePreferences {
  essential: boolean;      // Always true (required for functionality)
  analytics: boolean;      // Google Analytics
  marketing: boolean;      // Marketing cookies, remarketing
  preferences: boolean;    // User preference storage
  timestamp: Date;
  version: string;         // Policy version when consent given
}

export interface CookieConsentState {
  hasConsented: boolean;
  preferences: CookiePreferences;
  needsConsent: boolean;
}

export const DEFAULT_COOKIE_PREFERENCES: CookiePreferences = {
  essential: true,          // Required for app to work
  analytics: false,         // Opt-in
  marketing: false,         // Opt-in
  preferences: true,        // Reasonable default
  timestamp: new Date(),
  version: '1.0',
};

export const COOKIE_CONSENT_STORAGE_KEY = 'tier1_cookie_consent';
export const COOKIE_POLICY_VERSION = '1.0';
